const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const fmtQty = (value) => {
  const number = Number(value || 0);
  if (!Number.isFinite(number)) return "";
  if (Math.abs(number - Math.trunc(number)) < 0.000001) return `${Math.trunc(number)}`;
  return number.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

export const getPrintTemplate = ({ headerInfo, representatives = [], rows = [], totalAmount = 0, summary }) => {
  const rowsHtml = rows
    .map(
      (row, index) => `
      <tr>
        <td class="center">${index + 1}</td>
        <td>${escapeHtml(row.itemName || "")}</td>
        <td class="center">${escapeHtml(row.unit || "")}</td>
        <td class="right">${fmtQty(row.quantityPrevious)}</td>
        <td class="right">${fmtQty(row.quantityReceived)}</td>
        <td class="right">${fmtQty(row.quantityTotal)}</td>
        <td class="right">${fmtQty(row.quantitySold)}</td>
        <td class="right">${fmtMoney(row.unitPrice)}</td>
        <td class="right">${fmtMoney(row.amount)}</td>
        <td class="right">${fmtQty(row.quantityRemaining)}</td>
      </tr>
    `
    )
    .join("");

  const repLines = [0, 1, 2, 3]
    .map((idx) => {
      const rep = representatives[idx] || {};
      const suffix = idx === 0 ? "có hàng đại lý (ký gửi)." : idx === 2 ? "nhận bán hàng đại lý (ký gửi)." : ".";
      return `
        <div>- Ông/Bà ${escapeHtml(rep.name || "")}
          chức vụ ${escapeHtml(rep.position || "")}
          Đại diện ${escapeHtml(rep.representative || "")} ${suffix}</div>
      `;
    })
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng Thanh Toán Hàng Đại Lý, Ký Gửi</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:26px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; margin-top:6px; font-style:italic; }
        .meta-right { text-align:right; margin-top:6px; line-height: 1.6; }
        .line { margin-top: 8px; line-height: 1.7; }
        table { width:100%; border-collapse:collapse; margin-top:10px; font-size:14px; }
        th, td { border:1px solid #000; padding:4px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .signatures { margin-top:22px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:45%; }
        .sign-spacer { height: 16px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Địa chỉ:</b> ${escapeHtml(headerInfo.address || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 01 - BH</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BẢNG THANH TOÁN HÀNG ĐẠI LÝ, KÝ GỬI</div>
      <div class="subtitle">Ngày ${escapeHtml(headerInfo.documentDate || ".../.../....")}</div>

      <div class="meta-right">
        <div>Quyển số: ${escapeHtml(headerInfo.bookNumber || "")}</div>
        <div>Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>
        <div>Nợ: ${escapeHtml(headerInfo.debitAccount || "")}</div>
        <div>Có: ${escapeHtml(headerInfo.creditAccount || "")}</div>
      </div>

      <div class="line">
        Căn cứ Hợp đồng số ${escapeHtml(headerInfo.contractNumber || "")}
        ngày ${escapeHtml(headerInfo.contractDate || ".../.../....")} về việc bán hàng đại lý (ký gửi),
      </div>

      <div class="line"><b>Chúng tôi gồm:</b></div>
      <div class="line">${repLines}</div>

      <div class="line"><b>I- Thanh quyết toán số hàng đại lý từ ngày ${escapeHtml(headerInfo.fromDate || ".../.../....")} đến ngày ${escapeHtml(headerInfo.toDate || ".../.../....")} như sau:</b></div>

      <table>
        <thead>
          <tr>
            <th rowspan="2" style="width:6%">Số TT</th>
            <th rowspan="2" style="width:24%">Tên, quy cách, phẩm chất sản phẩm (hàng hóa)</th>
            <th rowspan="2" style="width:8%">Đơn vị tính</th>
            <th rowspan="2">Số lượng tồn đầu kỳ</th>
            <th rowspan="2">Số lượng nhận trong kỳ</th>
            <th rowspan="2">Tổng số</th>
            <th colspan="3">Số hàng đã bán trong kỳ</th>
            <th rowspan="2" style="width:10%">Số lượng tồn cuối kỳ</th>
          </tr>
          <tr>
            <th>Số lượng</th>
            <th>Đơn giá</th>
            <th>Số tiền</th>
          </tr>
          <tr>
            <th>A</th><th>B</th><th>C</th><th>1</th><th>2</th><th>3 = 1+2</th><th>4</th><th>5</th><th>6</th><th>7 = 3-4</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="6" class="center"><b>Cộng</b></td>
            <td class="center"><b>x</b></td>
            <td class="center"><b>x</b></td>
            <td class="right"><b>${fmtMoney(totalAmount)}</b></td>
            <td class="center"><b>x</b></td>
          </tr>
        </tbody>
      </table>

      <div class="line"><b>II.</b> Số tiền còn nợ của các kỳ trước: ${fmtMoney(summary?.previousDebt || 0)}</div>
      <div class="line"><b>III.</b> Số tiền phải thanh toán đến kỳ này (III = II + Cột 6): ${fmtMoney(summary?.payableNew || 0)}</div>
      <div class="line"><b>IV.</b> Số tiền được nhận lại:</div>
      <div class="line">+ Hoa hồng: ${fmtMoney(summary?.commission || 0)}</div>
      <div class="line">+ Thuế nộp hộ: ${fmtMoney(summary?.taxPaid || 0)}</div>
      <div class="line">+ Chi phí (nếu có): ${fmtMoney(summary?.otherExpense || 0)}</div>
      <div class="line"><b>V.</b> Số tiền thanh toán kỳ này:</div>
      <div class="line">+ Tiền mặt: ${fmtMoney(summary?.paidCash || 0)}</div>
      <div class="line">+ Séc: ${fmtMoney(summary?.paidCheque || 0)}</div>
      <div class="line"><b>VI.</b> Số tiền nợ lại (VI = III - IV - V): ${fmtMoney(summary?.remainingDebt || 0)}</div>
      <div class="line"><b>* Ghi chú:</b> ${escapeHtml(headerInfo.note || "")}</div>

      <div class="signatures">
        <div class="sign-col" style="width:33%">
          <div class="sign-spacer"></div>
          <div><b>Giám đốc đơn vị gửi hàng đại lý (ký gửi)</b></div>
          <div><i>(Ký, họ tên, đóng dấu)</i></div>
        </div>
        <div class="sign-col" style="width:33%">
          <div class="sign-spacer"></div>
          <div><b>Người lập bảng thanh toán</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col" style="width:33%">
          <div class="sign-spacer"></div>
          <div><b>Giám đốc đơn vị nhận bán hàng đại lý</b></div>
          <div><i>(Ký, họ tên, đóng dấu)</i></div>
        </div>
      </div>
      <div class="signatures" style="margin-top:40px;">
        <div class="sign-col" style="width:50%">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng đơn vị gửi hàng đại lý (ký gửi)</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col" style="width:50%">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng đơn vị nhận bán hàng đại lý</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
